// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1ACbz","label":"Category_label__5iJgK","content":"Category_content__10gIC","header":"Category_header__NIoi3","location":"Category_location__3r857"};